/**
 * Encodes a string to base64, supporting Unicode characters
 * @param str The string to encode
 * @returns The base64 encoded string
 */
export function encodeBase64Unicode(str: string): string {
  const utf8Bytes = new TextEncoder().encode(str);
  const binaryString = Array.from(utf8Bytes, (byte) => String.fromCharCode(byte)).join('');
  return btoa(binaryString);
}
